import { BtnClear, BtnSearch } from 'components/Button/ButtonAll'
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem'
import React from 'react'
import { FormProvider } from 'react-hook-form'
import { Grid } from '@mui/material'
import DataGrid from 'components/DataGrid';
import { useFundIncomeActual } from '../hooks/useFundIncomeActual'
import RenderCellPopoverUpdate from '../Ticket/components/RenderCellPopoverUpdate'

const FundIncomeActualList = () => {
    //#region Hook
    const {
        isPermission,
        dataColumn,
        formSearch,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        handleClearSearch,
        anchorEl,
        setAnchorEl,
        messagePopper,
    } = useFundIncomeActual()
    // #endregion

    return (
        <Grid container spacing={1} justifyContent={'flex-start'}>
            <Grid item xs={12} >
                <FormProvider {...formSearch}>
                    <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                        <Grid item xs={12} sm={4} md={3}>
                            <DatePickerItem
                                id={`dDate`}
                                name={`dDate`}
                                label={`ประจำเดือน-ปี`}
                                fullWidth
                                disabled={false}
                                IsMonthYearPicker
                                format="MMMM YYYY"
                            />
                        </Grid>
                        <Grid item xs={12} md={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
                <DataGrid
                    columns={dataColumn}
                    isShowCheckBox={isPermission && dataRow.arrRows.length !== 0}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isHiddenFooter={dataRow.arrRows.length === 0}
                    onDelete={onDelete}
                    sTableID='fundExpenseplan'
                    isHiddenToolHead
                    onRowSelectable={(p) => p.row.isAllowDelete}
                />
            </Grid>
            <RenderCellPopoverUpdate
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                MessagePopper={messagePopper}
            />
        </Grid>
    )
}

export default FundIncomeActualList